module.exports = __webpack_public_path__ + "static/media/Follower_Button-6.0d837f94.png";